$(document).ready(function() {
  $('.megamenu-dropdown-items .megamenu-items:first-child').addClass('show');
  $('.sub-menu-collection-image-1').addClass('active');
  $(document).on('mouseover', '.megamenu-dropdown-items .megamenu-items', function() {
    $('.megamenu-dropdown-items .megamenu-items').removeClass('show');
    $(this).addClass('show');
  });

   $(document).on('mouseover', '.megamenu-dropdown-items .sublink-items', function() {
    var itemClass = $(this).attr('class').split(' ')[1];
    $('.sub-menu-collection-image-1').removeClass('active');
    $('.sub-menu-collection-image').removeClass('active');
    $('.sub-menu-collection-image.' + itemClass).addClass('active');
  });

    $(document).on('mouseover', '.megamenu-items .menu-heading', function() {
      $('.sub-menu-collection-image-1').removeClass('active');
      var index = $(this).index('.menu-heading');
      $('.sub-menu-collection-image-1').eq(index).addClass('active');
    });
  
});